import { render, staticRenderFns } from "./Asides.vue?vue&type=template&id=7e2cb2d1&scoped=true"
import script from "./Asides.vue?vue&type=script&lang=js"
export * from "./Asides.vue?vue&type=script&lang=js"
import style0 from "./Asides.vue?vue&type=style&index=0&id=7e2cb2d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2cb2d1",
  null
  
)

export default component.exports